import { render, staticRenderFns } from "./userLeave.vue?vue&type=template&id=6d30db5d&"
import script from "./userLeave.vue?vue&type=script&lang=ts&"
export * from "./userLeave.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports